import _ from 'lodash';

import AgentPhonePreferences from 'models/agent_phone_preferences';

export default class AgentVoiceCapabilitiesChecker {
  constructor(context) {
    this.context = context;
  }

  canHandlePhoneCalls() {
    let currentAgent = this.context.stores.currentAgent.get();
    if (!currentAgent) {
      return false;
    }
    let appFeatures = this.context.stores.appFeatures.get();
    let agentPhonePreference = _.get(currentAgent, 'voiceConfiguration.preference');
    let connectionState = this.context.stores.connectionState.get();
    let isBrowserPhoneAvailable = connectionState.isBrowserPhoneAvailable();

    switch (agentPhonePreference) {
      case AgentPhonePreferences.BROWSER:
      case AgentPhonePreferences.NONE: {
        return appFeatures.isEnabled('webRTC') && appFeatures.isEnabled('microphone') && isBrowserPhoneAvailable;
      }
      case AgentPhonePreferences.DIRECT_DIAL:
        return appFeatures.isEnabled('directDial');
      case AgentPhonePreferences.STATION:
        return appFeatures.isEnabled('telephonyApi') || appFeatures.isEnabled('sip');
      default:
        return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/configuration/lib/agent_voice_capabilities_checker.js